const cn = {
   
    message: {
        title1: '远程控制智能家居，科技、安全又省心',
        content1:' AigoSmart助您能远程管理和控制家庭智能电器，设备之间也能彼此感知联动，一键触发即可使家庭各种电器进入您预设的状态，为您打造安全无忧的智能家庭生活。',
        title2:"AigoSmart为Aigostar全新子品牌",
        content2:"产品目前销往西班牙、葡萄牙、法国、意大利、荷兰、德国、芬兰、丹麦、波兰、俄罗斯、希腊、奥地利、瑞士、捷克、匈牙利、斯洛伐克等欧洲国家和地区。",
        content3:" AIGOSTAR多款厨房类、洗熨类小家电产品连续占据",
        content4:" 销量排行前十名。",
        title3:"品牌荣誉",
        content5:"快速 . 开放 . 创新 . 坚持",
        loading: '加载中',
        submit: '提交',
        contactUs:"联系我们",
        privacy:"隐私协议",
        policy:"服务政策",
        download:"下载",

    },

    wisdomleads: {
        title1: '远程控制智能家居，科技、安全又省心',
        content1:' wisdomleads助您能远程管理和控制家庭智能电器，设备之间也能彼此感知联动，一键触发即可使家庭各种电器进入您预设的状态，为您打造安全无忧的智能家庭生活。',
        title2:"wisdomleads为Aigostar全新子品牌",
        content2:"产品目前销往西班牙、葡萄牙、法国、意大利、荷兰、德国、芬兰、丹麦、波兰、俄罗斯、希腊、奥地利、瑞士、捷克、匈牙利、斯洛伐克等欧洲国家和地区。",
        content3:" wisdomleads多款厨房类、洗熨类小家电产品连续占据",
        content4:" 销量排行前十名。",
        title3:"品牌荣誉",
        content5:"快速 . 开放 . 创新 . 坚持",
        loading: '加载中',
        submit: '提交',
        contactUs:"联系我们",
        privacy:"隐私协议",
        policy:"服务政策",
        download:"下载",

    },

    v119:{

        password:"密码",
        back:"返回",
         account: '填写账号',
         VerifyAccount:"验证账号",
         confire:"确认",
         complete:"完成",
         loginAccount:"登录账号",
         VerifyCode:"验证码",
         preview:"上一步",
         next:"下一步",
         enterEmail:"输入邮箱",
         phone:"手机登录",
         email:"邮箱登录",
         pleaseenter:"请输入",
         emailError:"邮箱格式错误",
         phoneError:"手机号格式错误",
         qcCodeError:"验证码错误",
         sendCode:"发送验证码",
         reSend:"重新发送",
         tip1:"提交注销申请前，平台将对以下信息验证，确保您的账号、财产安全:",
         tip2:"账号处于安全状态",
         tip3:"15天内无绑定手机/邮箱、修改密码、更换登录设备、等敏感操作",
         tip4:"账号无运行智能设备",
         tip5:"您已离线（或者未绑定）智能设备",
         tip6:"账户无财产风险",
         tip7:"15天内无更密码、无购买记录、无绑定银行卡等敏感操作",
         accountCancellation:"账号注销",
         tip8:"感谢您一直以来的陪伴。很遗憾，AigoSmart将无法继续为您提供服务。注销账号前，我们会再次对您账号进行审核，请您知悉，注销成功后以下信息将被删除.",
         tip9:"感谢您一直以来的陪伴。很遗憾，Wisdomleads将无法继续为您提供服务。注销账号前，我们会再次对您账号进行审核，请您知悉，注销成功后以下信息将被删除.",
         tip10:"1、智能模块，房间，家庭，设备联网信息将被永远删除且无法恢复",
         tip11:"2、场景，自动化，自定义菜谱等信息将被永远删除且无法恢复",
         tip13:"3、在平台的所有账户信息，服务记录，消费情况等信息将被永远删除且无法恢复",
         tip14:"4、您将无法登录、使用本AigoSmart账号。您的家人/朋友无法通过本账号共享设备给你",
         tip14w:"4、您将无法登录、使用本Wisdomleads账号。您的家人/朋友无法通过本账号共享设备给你",
         tip15:"5、您AigoSmart账号的个人资料和历史消息（包含头像、昵称、设备告警信息、平台推送、家庭消息等）等都将无法找回",
         tip15w:"5、您Wisdomleads账号的个人资料和历史消息（包含头像、昵称、设备告警信息、平台推送、家庭消息等）等都将无法找回",
         tip16:"6、您通过此账号前需妥善处理账户资金（积分、会员等级、资格、订单、优惠券、道具及其他有价服务），注销账号后将视为您自行放弃且无法继续使用。您理解并同意，AigoSmart无法协助您恢复前述服务",
         tip16w:"6、您通过此账号前需妥善处理账户资金（积分、会员等级、资格、订单、优惠券、道具及其他有价服务），注销账号后将视为您自行放弃且无法继续使用。您理解并同意，Wisdomleads无法协助您恢复前述服务",
         tip17:"平台将在15天内处理您的申请并删除您的所有数据。15天内，请不要登录平台，以确保注销顺利完成",
         tip18:"请输入验证码",
         tip12:"您目前不能注销",
         tip20:"对平台建议(选填)",
         errorMsg1:"用户不存在",
         errorMsg2:"用户已经申请注销",
         errorMsg3:"用户15天内存在风险操作，如修改密码、更换设备等，禁止注销",
         errorMsg4:"验证码不正确",
         tip21:"请稍后,正在进行人机验证",
    }   
   
    
}

export default cn;